module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"moreBooks":"More |Books","nextChapter":"Next <br> Chapter:","chapter":"Chapter"},"ar":{"moreBooks":"المزيد","nextChapter":"الفصل  <br> التالي","chapter":"فصل"}}')
  delete Component.options._Ctor
}
